import { render, staticRenderFns } from "./MailboxSettingsModal.vue?vue&type=template&id=06824b4e&"
import script from "./MailboxSettingsModal.vue?vue&type=script&lang=js&"
export * from "./MailboxSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06824b4e')) {
      api.createRecord('06824b4e', component.options)
    } else {
      api.reload('06824b4e', component.options)
    }
    module.hot.accept("./MailboxSettingsModal.vue?vue&type=template&id=06824b4e&", function () {
      api.rerender('06824b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/MailboxSettingsModal.vue"
export default component.exports